/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { json } from 'stream/consumers'

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import CloseIcon from '@mui/icons-material/Close'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import NetworkCheckRoundedIcon from '@mui/icons-material/NetworkCheckRounded'
import PublishedWithChangesRoundedIcon from '@mui/icons-material/PublishedWithChangesRounded'
import { LoadingButton } from '@mui/lab'
import 'react-multi-date-picker/styles/layouts/mobile.css'
import {
  Box,
  Card,
  Container,
  DialogContentText,
  Fade,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { Dispatch } from '@reduxjs/toolkit'
import { toFarsiDigits } from 'farsi-digits'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import InputIcon from 'react-multi-date-picker/components/input_icon'
import TimePicker from 'react-multi-date-picker/plugins/time_picker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  FacebookShareCount,
  HatenaShareCount,
  OKShareCount,
  PinterestShareCount,
  RedditShareCount,
  TumblrShareCount,
  VKShareCount,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
  EmailShareButton,
  FacebookShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from 'react-share'
import sf from 'seconds-formater'
import swal from 'sweetalert'
//  تصاویر  آیکن زمان های گذشته

import iranflag12 from '../../assests/icons/12.png'
import iranflag2 from '../../assests/icons/2.png'
import iranflag24 from '../../assests/icons/24.png'
import iranflag48 from '../../assests/icons/48.png'
import iranflag6 from '../../assests/icons/6.png'
import * as routes from '../../config/constants'
import ExcelExport from '../../Excelexport'
import Button from '../../shared/Button'
import {
  getDateFrom,
  getDateTo,
  getDeviceId,
  getIdInterval,
  setDateFrom,
  setDateTo,
  setIdInterval,
  setResetDate,
} from '../../store/date'
import {
  getDistanceTraveled,
  getLoading,
  getOdo,
  getOdoItem,
  getPositionList,
  getTraveledDistance,
  resetOdo,
  resetTraveledDistance,
} from '../../store/devices'
import SecurityScreen from './SecurityScreen'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export interface DialogTitleProps {
  id: string
  children?: React.ReactNode
  onClose: () => void
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}
const BootstrapDialog1 = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export interface DialogTitleProps1 {
  id: string
  children?: React.ReactNode
  onClose: () => void
}

function BootstrapDialogTitle1(props: DialogTitleProps1) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}
const PathsTraveledScreen = () => {
  const IdInterval = useSelector(getIdInterval)
  const deviceId = useSelector(getDeviceId)
  const { t } = useTranslation()
  const location = useLocation()
  const rows = useSelector(getDistanceTraveled)
  const dispatch = useDispatch<Dispatch<any>>()
  const startDate = useSelector(getDateFrom)
  const endDate = useSelector(getDateTo)
  const obdItem = useSelector(getOdoItem)
  const loading = useSelector(getLoading)
  const navigate = useNavigate()
  const [isSearch, setIsSearch] = useState(false)
  // تابع تبدیل تاریخ شمسی به میلادی
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    var replaceTime = _.replace(time1, 'T', ' ')
    replaceTime = _.replace(replaceTime, 'Z', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  const shamsiDay = (time: any) => {
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.weekDay.name
  }

  const { id } = useParams()
  useEffect(() => {
    if (id === undefined) return
    dispatch(getOdo(id))
  }, [id])

  function handleChange(dateFrom: any) {
    const date = new DateObject({
      calendar: persian,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      date: `${dateFrom.year}-${dateFrom.month}-${dateFrom.day} ${dateFrom.hour}:${dateFrom.minute}`,
    })
    const a = date.format('YYYY-MM-DD HH:mm')
    setDate1(a)

    date.subtract(3, 'hour')
    date.subtract(30, 'minute')
    // date.add(1, "days");

    date.convert(gregorian, gregorian_en)
    dispatch(setDateFrom(date.format('YYYY-MM-DD HH:mm')))
  }
  function handleChangeDateTo(dateTo: any) {
    // تغییرات روی تاریخ رو اینجا اعمال کنید
    const date = new DateObject({
      calendar: persian,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      date: `${dateTo.year}-${dateTo.month}-${dateTo.day} ${dateTo.hour}:${dateTo.minute}`,
    })

    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    date.convert(gregorian, gregorian_en)
    dispatch(setDateTo(date.format('YYYY-MM-DD HH:mm')))
  }
  const handleClick = () => {
    if (startDate === '' || endDate === '') {
      const a = swal('تاریخ شروع یا تاریخ پایان  انتخاب نشده است', 'جهت ادامه کلیک کنید', 'warning')
    } else {
      dispatch(
        getTraveledDistance({
          deviceId: location.state.location.state.id,
          startDateTime: startDate,
          endDateTime: endDate,
        }),
      )
      setIsSearch(true)
      dispatch(setResetDate(''))
    }
  }
  const [date1, setDate1] = useState<string>()
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))
  const convertKilometer = (meter: number) => {
    if (meter < 1000) {
      return _.split(meter.toString(), '.', 1) + 'متر'
    } else {
      const convert = Math.round(meter / 100) / 10
      const convertation: any = _.split(convert.toString(), '.', 2)
      const num1 = convertation[1] !== undefined ? convertation[1] * 100 + 'متر' : ''

      return convertation[0] + 'کیلومتر' + num1
    }
  }
  const ExcelExportData = [
    {
      'تاریخ شروع': shamsi(rows?.otherData?.startDateTime),
      'تاریخ پایان': shamsi(rows?.otherData?.endDateTime),
      'تعداد سفرها': rows?.otherData?.tripsCount,
      'زمان کلی سفرها':
        rows?.otherData !== undefined && rows?.otherData !== null
          ? sf.convert(rows?.otherData?.onTimeSeconds).format('HH:MM:SS')
          : '',
      /* mehdi 'مسافت طی شده': convertKilometer(rows?.otherData?.totalDistance),
      'میزان مصرف سوخت': rows?.otherData?.totalFuelConsumption, */
      'زمان غیرفعال بودن دستگاه': rows?.otherData?.deviceOffTimeSeconds,
    },
  ]

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }))
  // لیست ستونهای جدول
  interface Column {
    id:
      | 'id'
      | 'day'
      // | 'tripId'
      | 'onTimeSeconds'
      | 'startDateTime'
      | 'endDateTime'
      | 'avgSpeed'
      | 'maxSpeed'
      /* mehdi| 'totalDistance'
      | 'fuelConsumption' */
      | 'map'
    label: string
    minWidth?: number
    align?: 'center'
    format?: (value: number) => string
  }
  const columns: readonly Column[] = [
    { id: 'id', label: t('screens.PathsTraveledScreen.id'), minWidth: 50, align: 'center' },
    { id: 'day', label: t('screens.PathsTraveledScreen.day'), minWidth: 50, align: 'center' },
    // { id: 'tripId', label: 'شماره سفر', minWidth: 100, align: 'center' },
    {
      id: 'onTimeSeconds',
      label: t('screens.PathsTraveledScreen.time_travel'),
      minWidth: 50,
      align: 'center',
    },
    {
      id: 'startDateTime',
      label: t('screens.PathsTraveledScreen.date_start'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'endDateTime',
      label: t('screens.PathsTraveledScreen.date_end'),
      minWidth: 100,
      align: 'center',
    },
    {
      id: 'avgSpeed',
      label: t('screens.PathsTraveledScreen.avg_speed'),
      minWidth: 60,
      align: 'center',
    },
    {
      id: 'maxSpeed',
      label: t('screens.PathsTraveledScreen.max_speed'),
      minWidth: 60,
      align: 'center',
    },
    /* mehdi{
      id: 'totalDistance',
      label: t('screens.PathsTraveledScreen.totalDistance'),
      minWidth: 50,
      align: 'center',
    },
    {
      id: 'fuelConsumption',
      label: t('screens.PathsTraveledScreen.fuelConsumption'),
      minWidth: 60,
      align: 'center',
    }, */
    { id: 'map', label: t('screens.PathsTraveledScreen.map'), minWidth: 100, align: 'center' },
  ]
  let nIntervId: any
  useEffect(() => {
    if (id !== deviceId) {
      dispatch(resetTraveledDistance)
      dispatch(resetOdo)
    } else {
      clearInterval(IdInterval)
    }
  }, [])
  useEffect(() => {
    return () => {
      nIntervId = setInterval(() => {
        dispatch(resetTraveledDistance)
        dispatch(resetOdo)
      }, 60000)
      dispatch(setIdInterval({ intervalId: nIntervId, deviceId: id }))
    }
  }, [])

  // const replaceTime1 = _.replace(obdItem.fromRegisteredTime, '.', '')

  const [alignment, setAlignment] = React.useState<string>('')

  const handleChangeToggle = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    setAlignment(newAlignment)
  }
  const handleYesterdayDay = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.subtract(1, 'day')
    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(1, 'day')
    // date.subtract(3, 'hour')
    // date.subtract(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(
      getTraveledDistance({
        deviceId: location.state.location.state.id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setIsSearch(true)
  }
  const handle12hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(15, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')

    date.add(12, 'hour')
    // date.add(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(
      getTraveledDistance({
        deviceId: location.state.location.state.id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setIsSearch(true)
  }
  const handle48hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.subtract(2, 'day')
    date.subtract(3, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(2, 'day')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(
      getTraveledDistance({
        deviceId: location.state.location.state.id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setIsSearch(true)
  }
  const handle6hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(9, 'hour')
    date.subtract(30, 'minute')

    const startDate1 = date.format('YYYY-MM-DD HH:mm')

    date.add(6, 'hour')
    // date.add(30, 'minute')

    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    dispatch(
      getTraveledDistance({
        deviceId: location.state.location.state.id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setIsSearch(true)
  }
  const handle2hourAgo = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })

    date.subtract(5, 'hour')
    date.subtract(30, 'minute')
    const startDate1 = date.format('YYYY-MM-DD HH:mm')
    date.add(2, 'hour')
    const endDate1 = date.format('YYYY-MM-DD HH:mm')

    // date.add(30, 'minute')

    dispatch(
      getTraveledDistance({
        deviceId: location.state.location.state.id,
        startDateTime: startDate1,
        endDateTime: endDate1,
      }),
    )
    setIsSearch(true)
  }
  const handleClickPosition = (tripId: number, start: string, end: string) => {
    dispatch(
      getPositionList({
        deviceId: location.state.location.state.id,
        startDateTime: start,
        endDateTime: end,
        allPositions: (tripId === 0)
      }),
    )
    navigate(`/${routes.LOCATION_TRIP}`)
  }

  const responsiveLoadingButton = {
    '&.MuiButtonBase-root': {
      width: { xs: '50%', sm: '50%' },
      // color: { xs: 'yellow', sm: 'blue' },
    },
  }

  const style = {
    direction: 'rtl',
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const [open1, setOpen1] = React.useState(false)

  const handleClickOpen1 = () => {
    setOpen1(true)
  }
  const handleClose1 = () => {
    setOpen1(false)
  }
  const sharedUrl = JSON.stringify(ExcelExportData)

  return (
    <Container fixed maxWidth='md'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'scroll',
          Height: '300vh',
        }}
      >
        <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 1, direction: 'ltr' }}>
          <ArrowBackRoundedIcon
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: 'red',
              borderRadius: '50%',
              color: '#fff',

              cursor: 'pointer',
            }}
          />
          <img alt='Logo' src='/images/TinyLogo.png' />
        </Box>
        <Box
          sx={{ position: 'relative', '& .MuiBackdrop-root': { backgroundColor: 'transparent' } }}
        >
          <Backdrop
            open={loading}
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, position: 'absolute' }}
          >
            <div className='progress'></div>
          </Backdrop>
          <Card
            sx={{
              color: 'grey.700',
              backgroundColor: '#fff',
              borderRadius: 1,
              p: 1.5,
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 0.5,
              direction: 'rtl',
            }}
          >
            <Box display='flex' justifyContent='space-between'>
              <NetworkCheckRoundedIcon />
              <Typography color='black'>{t('screens.PathsTraveledScreen.KM_from_ECU')}</Typography>
            </Box>
            <Typography color='black'>{toFarsiDigits(_.toNumber(obdItem.fromOBD))} </Typography>
          </Card>
          <Card
            sx={{
              color: 'grey.700',
              backgroundColor: '#fff',
              borderRadius: 1,
              p: 1.5,
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 0.5,
              direction: 'rtl',
            }}
          >
            <Box display='flex' justifyContent='space-between'>
              <CalendarMonthRoundedIcon />
              <Typography color='black'>
                {t('screens.PathsTraveledScreen.Power_on_time_from_the_device_installation date')}
              </Typography>
            </Box>
            <Typography color='black' sx={{ textAlign: 'end' }}>
              {shamsi(obdItem.deviceRegisteredTime)}
            </Typography>
          </Card>
          <Card
            sx={{
              color: 'grey.700',
              backgroundColor: '#fff',
              borderRadius: 1,
              p: 1.5,
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 0.5,
              direction: 'rtl',
            }}
          >
            <Box display='flex' justifyContent='space-between'>
              <PublishedWithChangesRoundedIcon />
              <Typography color='black'>
                {t('screens.PathsTraveledScreen.KM_from_date_install_device')}
              </Typography>
            </Box>
            <Typography color='black'>
              {toFarsiDigits(_.toNumber(_.split(obdItem.fromRegisteredTime, '.', 1)))}
            </Typography>
          </Card>
        </Box>

        {/* <Box>
          <Typography sx={responsiveBadge}>sajjad</Typography>
        </Box> */}

        {/* <Box display='flex' justifyContent='space-between' sx={{ mb: 1, direction: 'ltr' }}>
          <Typography sx={{ backgroundColor: '#CCD1E4', borderRadius: 5, p: 0.5 }}>
            {toFarsiDigits(_.toNumber(replaceTime))} KM
          </Typography>
          <Typography sx={{ p: 0 }}>ECU کیلومتر از</Typography>
        </Box>
        <Box display='flex' justifyContent='space-between' sx={{ mb: 1, direction: 'ltr' }}>
          <Typography sx={{ backgroundColor: '#CCD1E4', borderRadius: 5, p: 0.5 }}>
            {shamsi(obdItem.deviceRegisteredTime)}
          </Typography>
          <Typography sx={{ p: 0 }}>تاریخ نصب دستگاه</Typography>
        </Box>
        <Box display='flex' justifyContent='space-between' sx={{ mb: 1, direction: 'ltr' }}>
          <Typography sx={{ backgroundColor: '#CCD1E4', borderRadius: 5, p: 0.5 }}>
            {toFarsiDigits(_.toNumber(replaceTime))} KM
          </Typography>
          <Typography sx={{ p: 0 }}>کیلومتر از تاریخ نصب دستگاه</Typography>
        </Box> */}
        <Box sx={{ background: 'linear-gradient(rgb(35 75 75), #aaaaaa)', p: 1, borderRadius: 2 }}>
          <Box
            alignItems='center'
            display='flex'
            flexDirection='column'
            justifyContent='center'
            sx={{
              p: 1,
              m: 0,
              borderRadius: 2,
              '& .rmdp-time-picker div input': { fontFamily: 'Vazir' },
              '& .rmdp-action-button': { fontFamily: 'Vazir' },
              '& .rmdp-input': { fontFamily: 'Vazir', minHeight: '40px', width: '200px' },
            }}
          >
            <div
              style={{
                direction: 'rtl',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <p style={{ width: '100px', textAlign: 'end' }}>
                {t('screens.PathsTraveledScreen.form_date')}
              </p>
              <DatePicker
                calendar={persian}
                className='rmdp-mobile'
                format='YYYY/MM/DD'
                locale={persian_fa}
                maxDate={new DateObject({ calendar: persian })}
                onChange={handleChange}
                plugins={[<TimePicker hideSeconds key={''} position='bottom' />]}
                render={<InputIcon />}
              />
            </div>
            <div
              style={{
                direction: 'rtl',

                display: 'flex',
                alignItems: 'center',
              }}
            >
              <p style={{ width: '100px', textAlign: 'end' }}>
                {t('screens.PathsTraveledScreen.to_date')}
              </p>
              <DatePicker
                calendar={persian}
                className='rmdp-mobile'
                format='YYYY/MM/DD'
                locale={persian_fa}
                minDate={date1}
                onChange={handleChangeDateTo}
                plugins={[<TimePicker hideSeconds key={''} position='bottom' />]}
                render={<InputIcon />}
                style={{ width: '100%' }}
                zIndex={10000000}
              />
            </div>
          </Box>

          <Box
            sx={{
              marginBottom: 0,
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              direction: 'ltr',
            }}
          >
            {rows !== undefined && rows?.count !== 0 && (
              <Button onClick={handleClickOpen} size='small' sx={{ mx: 1, p: 0 }}>
                {t('screens.PathsTraveledScreen.general_report')}
              </Button>
            )}

            <LoadingButton onClick={handleClick} sx={responsiveLoadingButton} variant='contained'>
              {t('screens.PathsTraveledScreen.send')}
            </LoadingButton>
          </Box>
        </Box>
        <Box sx={{ mt: 1, direction: 'ltr', display: 'flex', justifyContent: 'center' }}>
          <ToggleButtonGroup
            aria-label='Platform'
            color='primary'
            exclusive
            onChange={handleChangeToggle}
            sx={{ maxHeight: 90, background: 'linear-gradient(rgb(247 252 252), #818181)' }}
            value={alignment}
          >
            <ToggleButton onClick={handle2hourAgo} value='2hourAgo'>
              <img src={iranflag2} width='30px' />
            </ToggleButton>
            <ToggleButton onClick={handle6hourAgo} value='6hourAgo'>
              <img src={iranflag6} width='30px' />
            </ToggleButton>
            <ToggleButton onClick={handle12hourAgo} value='12hourAgo'>
              <img src={iranflag12} width='30px' />
            </ToggleButton>
            <ToggleButton onClick={handleYesterdayDay} value='yesterday'>
              <img src={iranflag24} width='30px' />
            </ToggleButton>
            <ToggleButton onClick={handle48hourAgo} value='48hourAgo'>
              <img src={iranflag48} width='30px' />
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        {rows?.data !== undefined && rows?.data.length !== 0 && (
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              overflowY: 'auto',
              flexWrap: 'nowrap',
              width: '100%',
              marginTop: 1,
            }}
          >
            <Paper sx={{ width: '100%', overflow: 'hidden', direction: 'rtl', marginBottom: 2 }}>
              <TableContainer sx={{ maxHeight: 400 }}>
                <Table aria-label='sticky table' size='small' stickyHeader>
                  <TableHead>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { backgroundColor: 'lightgray' } }}
                    >
                      {columns.map((column) => (
                        <TableCell
                          align={column.align}
                          key={column.id}
                          style={{ minWidth: column.minWidth, padding: '0' }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.data?.map((row: any, index: number) => {
                      return (
                        <TableRow
                          key={row.tripId}
                          sx={{ '&:nth-of-type(odd)': { backgroundColor: (row.tripId === 0 ? 'yellow':'#fff') } }}
                          tabIndex={-1}
                        >
                          <TableCell align='center'>{index + 1}</TableCell>
                          <TableCell align='center'>{shamsiDay(row.endDateTime)}</TableCell>
                          {/* <TableCell align='center'>{row.tripId}</TableCell> */}
                          <TableCell align='center'>
                            {sf.convert(row.onTimeSeconds).format('HH:MM:SS')}
                          </TableCell>
                          <TableCell align='center'>{shamsi(row.startDateTime)}</TableCell>
                          <TableCell align='center'>{shamsi(row.endDateTime)}</TableCell>
                          <TableCell align='center'>{_.split(row.avgSpeed, '.', 1)}</TableCell>
                          <TableCell align='center'>{_.replace(row.maxSpeed, '.', '')}</TableCell>
                          {/* mehdi<TableCell align='center'>
                            {convertKilometer(row.totalDistance)}
                          </TableCell>
                          <TableCell align='center'>{row.fuelConsumption}</TableCell> */}
                          <TableCell align='center'>
                            <IconButton
                              onClick={() =>
                                handleClickPosition(row.tripId, row.startDateTime, row.endDateTime)
                              }
                            >
                              <LocationOnIcon sx={{ color: 'red' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        )}
        {rows?.data.length === 0 && isSearch && !loading && (
          <Box display='flex' justifyContent='center'>
            <Card
              sx={{
                p: 1,
                width: { xs: 1, sx: 2 / 4, md: 2 / 4, lg: 2 / 4 },
                m: 1,
                textAlign: 'center',
              }}
            >
              <Typography>{t('screens.PathsTraveledScreen.no_info')}</Typography>
            </Card>
          </Box>
        )}

        <div>
          <BootstrapDialog
            aria-labelledby='customized-dialog-title'
            onClose={handleClose}
            open={open}
            sx={{ direction: 'rtl' }}
          >
            <BootstrapDialogTitle id='customized-dialog-title' onClose={handleClose}>
              مجموع آمار خودرو
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Typography component='h2' id='transition-modal-title' variant='h6'>
                از تاریخ:{shamsi(rows?.otherData?.startDateTime)}
              </Typography>
              <Typography component='h2' id='transition-modal-title' variant='h6'>
                تا تاریخ:{shamsi(rows?.otherData?.endDateTime)}
              </Typography>
              <Typography component='h2' id='transition-modal-title' variant='h6'>
                تعداد سفرها:{rows?.otherData?.tripsCount}
              </Typography>
              <Typography component='h2' id='transition-modal-title' variant='h6'>
                زمان کلی سفرها:
                {rows?.otherData !== undefined &&
                  rows?.otherData !== null &&
                  sf.convert(rows?.otherData?.onTimeSeconds).format('HH:MM:SS')}
              </Typography>
              {/* mehdi<Typography component='h2' id='transition-modal-title' variant='h6'>
                مسافت طی شده: {convertKilometer(rows?.otherData?.totalDistance)}
                </Typography> */}
            </DialogContent>
            <DialogActions>
              <ExcelExport excelData={ExcelExportData} fileName={'Excel Export'} />
              <Button onClick={handleClickOpen1} sx={{ mx: 1 }}>
                اشتراک گذاری
              </Button>
            </DialogActions>
          </BootstrapDialog>
        </div>
        <div>
          <Dialog
            aria-describedby='alert-dialog-description'
            aria-labelledby='alert-dialog-title'
            onClose={handleClose1}
            open={open1}
          >
            <DialogTitle id='alert-dialog-title'>{'...اشتراک گذاری با '}</DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                <TwitterShareButton url={sharedUrl}>
                  <TwitterIcon round={true} size={50} style={{ margin: '5px' }} />
                </TwitterShareButton>
                <FacebookShareCount url={sharedUrl} />

                <FacebookShareButton url={sharedUrl}>
                  <FacebookIcon round={true} size={50} style={{ margin: '5px' }} />
                </FacebookShareButton>

                <WhatsappShareButton url={sharedUrl}>
                  <WhatsappIcon round={true} size={50} style={{ margin: '5px' }} />
                </WhatsappShareButton>
                <TelegramShareButton url={sharedUrl}>
                  <TelegramIcon round={true} size={50} style={{ margin: '5px' }} />
                </TelegramShareButton>

                <LinkedinShareButton url={sharedUrl}>
                  <LinkedinIcon round={true} size={50} style={{ margin: '5px' }} />
                </LinkedinShareButton>

                <EmailShareButton url={sharedUrl}>
                  <EmailIcon round={true} size={50} style={{ margin: '5px' }} />
                </EmailShareButton>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </div>
        {/* <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <div className='progress'></div>
        </Backdrop> */}
      </Box>
    </Container>
  )
}

export default PathsTraveledScreen
